module.exports = {
    application: 'balus-app',
    token: '5246d62767494470abfdbc6d1a011cf4',
    enabled: true
};



// WEBPACK FOOTER //
// ../etc/config/trackjs/production.js